import { Component, Input, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-loader-list-placeholder',
    templateUrl: './loader-list-placeholder.component.html',
    styleUrls: ['./loader-list-placeholder.component.scss'],
    imports: [NgIf],
    standalone: true
})
export class LoaderListPlaceholderComponent implements OnInit {

  @Input() hasLabel = false;

  constructor() { }

  ngOnInit() {
  }

}
